import type { ChangeEvent, FC } from "react";
import type { IconButtonProps } from "@mui/material";
import { IconButton } from "@mui/material";
import styles from "../styles.module.css";
import { AppPopover } from "../../../AppPopover";
import { AppInput } from "../../../../shared/components/AppInput";
import classNames from "classnames";
import { EditIcon } from "../../../../shared/icons/EditIcon";
import { useTranslation } from "react-i18next";
import { usePopover } from "../../../hooks/use-popover";

interface Props extends IconButtonProps {
  name: string;
  onEditName: () => void;
  handleNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onCancel: () => void;
  isDisabled?: boolean;
}

export const ChangeNameVersionAction: FC<Props> = ({
  name,
  onEditName,
  handleNameChange,
  isDisabled,
  onCancel,
  ...props
}) => {
  const {
    anchorPopoverEl,
    openPopover,
    handleOpenPopover,
    handleClosePopover,
  } = usePopover();
  const { t } = useTranslation();
  return (
    <>
      <IconButton
        className={styles["action-button"]}
        onClick={handleOpenPopover}
        disabled={isDisabled}
        {...props}
      >
        <EditIcon
          className={classNames({
            [styles["disabled"]]: isDisabled,
          })}
        />
      </IconButton>
      <AppPopover
        anchorEl={anchorPopoverEl}
        onClose={() => {
          onCancel();
          handleClosePopover();
        }}
        onOk={() => {
          onEditName();
          handleClosePopover();
        }}
        open={openPopover}
      >
        <AppInput
          value={name}
          placeholder={t("versioning.change_name_popover_placeholder")}
          onChange={handleNameChange}
        />
      </AppPopover>
    </>
  );
};
